/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WorkOrderDetailTicketDto } from './WorkOrderDetailTicketDto';
import {
    WorkOrderDetailTicketDtoFromJSON,
    WorkOrderDetailTicketDtoFromJSONTyped,
    WorkOrderDetailTicketDtoToJSON,
    WorkOrderDetailTicketDtoToJSONTyped,
} from './WorkOrderDetailTicketDto';

/**
 * 
 * @export
 * @interface WorkOrderDetailDto
 */
export interface WorkOrderDetailDto {
    /**
     * 
     * @type {string}
     * @memberof WorkOrderDetailDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderDetailDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderDetailDto
     */
    status: WorkOrderDetailDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkOrderDetailDto
     */
    siteId: string;
    /**
     * External OT number (Monprojet Ordre d’exécution)
     * @type {object}
     * @memberof WorkOrderDetailDto
     */
    externalIdentifier?: object | null;
    /**
     * 
     * @type {object}
     * @memberof WorkOrderDetailDto
     */
    assignedTechnicianId?: object | null;
    /**
     * 
     * @type {Date}
     * @memberof WorkOrderDetailDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof WorkOrderDetailDto
     */
    updatedAt: Date;
    /**
     * 
     * @type {Array<WorkOrderDetailTicketDto>}
     * @memberof WorkOrderDetailDto
     */
    tickets: Array<WorkOrderDetailTicketDto>;
    /**
     * 
     * @type {Date}
     * @memberof WorkOrderDetailDto
     */
    scheduledFor?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof WorkOrderDetailDto
     */
    startedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof WorkOrderDetailDto
     */
    completedAt?: Date | null;
    /**
     * 
     * @type {object}
     * @memberof WorkOrderDetailDto
     */
    onHoldReason?: object | null;
}


/**
 * @export
 */
export const WorkOrderDetailDtoStatusEnum = {
    Planned: 'PLANNED',
    Assigned: 'ASSIGNED',
    InProgress: 'IN_PROGRESS',
    OnHold: 'ON_HOLD',
    Completed: 'COMPLETED',
    Closed: 'CLOSED',
    Archived: 'ARCHIVED',
    Cancelled: 'CANCELLED'
} as const;
export type WorkOrderDetailDtoStatusEnum = typeof WorkOrderDetailDtoStatusEnum[keyof typeof WorkOrderDetailDtoStatusEnum];


/**
 * Check if a given object implements the WorkOrderDetailDto interface.
 */
export function instanceOfWorkOrderDetailDto(value: object): value is WorkOrderDetailDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('siteId' in value) || value['siteId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('tickets' in value) || value['tickets'] === undefined) return false;
    return true;
}

export function WorkOrderDetailDtoFromJSON(json: any): WorkOrderDetailDto {
    return WorkOrderDetailDtoFromJSONTyped(json, false);
}

export function WorkOrderDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkOrderDetailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'status': json['status'],
        'siteId': json['siteId'],
        'externalIdentifier': json['externalIdentifier'] == null ? undefined : json['externalIdentifier'],
        'assignedTechnicianId': json['assignedTechnicianId'] == null ? undefined : json['assignedTechnicianId'],
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'tickets': ((json['tickets'] as Array<any>).map(WorkOrderDetailTicketDtoFromJSON)),
        'scheduledFor': json['scheduledFor'] == null ? undefined : (new Date(json['scheduledFor'])),
        'startedAt': json['startedAt'] == null ? undefined : (new Date(json['startedAt'])),
        'completedAt': json['completedAt'] == null ? undefined : (new Date(json['completedAt'])),
        'onHoldReason': json['onHoldReason'] == null ? undefined : json['onHoldReason'],
    };
}

export function WorkOrderDetailDtoToJSON(json: any): WorkOrderDetailDto {
    return WorkOrderDetailDtoToJSONTyped(json, false);
}

export function WorkOrderDetailDtoToJSONTyped(value?: WorkOrderDetailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'status': value['status'],
        'siteId': value['siteId'],
        'externalIdentifier': value['externalIdentifier'],
        'assignedTechnicianId': value['assignedTechnicianId'],
        'createdAt': value['createdAt'].toISOString(),
        'updatedAt': value['updatedAt'].toISOString(),
        'tickets': ((value['tickets'] as Array<any>).map(WorkOrderDetailTicketDtoToJSON)),
        'scheduledFor': value['scheduledFor'] == null ? value['scheduledFor'] : value['scheduledFor'].toISOString(),
        'startedAt': value['startedAt'] == null ? value['startedAt'] : value['startedAt'].toISOString(),
        'completedAt': value['completedAt'] == null ? value['completedAt'] : value['completedAt'].toISOString(),
        'onHoldReason': value['onHoldReason'],
    };
}

